import React from "react";
import Box from "@mui/material/Box";

const LaunchAdnexioContainer = ({ children, src, sx, ...rest }) => {
  return (
    <Box
      {...rest}
      sx={{ ...sx }}
      height="100vh"
      width="100vw"
      position="relative"
      bgcolor="white.main"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        as="img"
        src={src}
        display={{ xs: "none", lg: "block" }}
        height="70%"
        position="absolute"
        left="-100px"
        bottom={0}
      />

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        mb={8}
      >
        {children}
      </Box>
    </Box>
  );
};

export default LaunchAdnexioContainer;
